// extracted by mini-css-extract-plugin
module.exports = {"Container":"_1FdiZ","Block":"_3sGEI","Icon":"MDgrR"};